import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Button, CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

function PaymentSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  useEffect(() => {
    const processPayment = async () => {
      try {
        const params = new URLSearchParams(location.search);
        
        // Garanti'den gelen parametreleri kontrol et
        const mdStatus = params.get('mdstatus');
        const procReturnCode = params.get('procreturncode');
        const response = params.get('response');
        const orderId = params.get('orderid');
        const hashParams = params.get('hashparams');
        const hash = params.get('hash');

        // Hash doğrulaması ve temel kontroller
        if (!hashParams || !hash) {
          throw new Error('Geçersiz ödeme yanıtı');
        }

        // Hash doğrulaması yap
        const paramList = hashParams.split(':');
        let digestData = '';
        
        paramList.forEach(param => {
          digestData += params.get(param) || '';
        });
        
        // Store key'i ekle
        digestData += process.env.REACT_APP_GARANTI_STORE_KEY;

        // Hash'i hesapla
        const encoder = new TextEncoder();
        const dataBuffer = encoder.encode(digestData);
        const hashBuffer = await crypto.subtle.digest('SHA-512', dataBuffer);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const calculatedHash = btoa(String.fromCharCode.apply(null, hashArray));

        if (hash !== calculatedHash) {
          throw new Error('Hash doğrulaması başarısız');
        }

        // İşlem başarılı mı kontrol et
        if (mdStatus === '1' && procReturnCode === '00' && response === '00') {
          // Sipariş durumunu güncelle
          const orderRef = doc(db, 'orders', orderId);
          await updateDoc(orderRef, {
            status: 'Ödeme Alındı',
            paymentDate: new Date().toISOString(),
            paymentResponse: Object.fromEntries(params)
          });
          
          setLoading(false);
        } else {
          throw new Error('Ödeme onaylanmadı');
        }
      } catch (error) {
        console.error('Ödeme işleme hatası:', error);
        setError(error.message || 'Ödeme işlenirken bir hata oluştu');
        setLoading(false);
        // Hata durumunda PaymentError sayfasına yönlendir
        navigate('/payment/error?errmsg=' + encodeURIComponent(error.message));
      }
    };

    processPayment();
  }, [location, navigate]);

  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        minHeight: '60vh'
      }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: { xs: '76px', sm: '84px' }, mb: 4 }}>
      <Box sx={{ 
        textAlign: 'center',
        py: 6,
        px: 4,
        bgcolor: '#f8f8f8',
        borderRadius: 2
      }}>
        {error ? (
          <>
            <Typography color="error" variant="h6" gutterBottom>
              {error}
            </Typography>
          </>
        ) : (
          <>
            <CheckCircleIcon sx={{ 
              fontSize: 64,
              color: 'success.main',
              mb: 2
            }} />
            <Typography variant="h5" gutterBottom>
              Ödemeniz Başarıyla Alındı
            </Typography>
            <Typography color="text.secondary" paragraph>
              Siparişiniz hazırlanmaya başlanacak
            </Typography>
          </>
        )}
        
        <Button 
          variant="contained"
          onClick={() => navigate('/orders')}
          sx={{ mt: 3 }}
        >
          Siparişlerimi Görüntüle
        </Button>
      </Box>
    </Container>
  );
}

export default PaymentSuccess; 